import { ApptTypeCode } from '../schemas/enums/apptTypeCode';
import { ClinSubtype } from '../schemas/getMetaAppointments';

export const filterClinSubtypesByApptType = (subtypes: ClinSubtype[], apptTypeCode?: ApptTypeCode) => {
  if (apptTypeCode !== 'IMG-REVIEW') return subtypes;

  return subtypes.filter(({ img_review_allowed }) => img_review_allowed !== false);
};
